import styled, { css } from 'styled-components';

import Select from '../../_shared/components/Select';
import Icon from '../../_shared/components/Icon';

export const StyledTradeFilterBar = styled.div.attrs(props => ({
  'data.testId': props.testId
}))`
  width: 100%;
  height: 60px;
  background: ${({ theme }) => theme.COLORS.BASE};
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
  border-radius: 3px;
  display: flex;
  justify-content: ${props => (props.hasDGN ? 'space-between' : 'flex-end')};
  align-items: center;
  padding: 12px 12px 12px 0;
  margin: 30px 0 18px;
`;

export const StyledDealerGroupFilter = styled.div`
  height: inherit;
  width: 240px;
  background-color: ${({ theme }) => theme.COLORS.NEUTRAL_5};
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px;
`;

export const StyledDropdownContainer = styled.div`
  height: 40px;
  max-width: 216px;
  padding: 9px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.COLORS.BASE};
  border: 1px solid ${({ theme }) => theme.COLORS.NEUTRAL_10};
`;

export const StyledSelect = styled(Select)`
  select {
    border-left: none;
    border-right: none;
    padding-left: 0;
    min-width: 170px;
    max-width: 170px;
    text-overflow: ellipsis;
    max-height: 40px;
  }

  div {
    right: 6px;
  }
`;

export const StyledIconContainer = styled.div`
  border-right: none;
  box-sizing: border-box;
  width: 12px;
  margin-right: 9px;
  display: flex;
  align-items: center;
`;

export const StyledOptionsFilter = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;
`;

export const StyledFiltersButton = styled.button`
  display: none;
  align-items: center;
  border: 2px solid ${({ theme }) => theme.COLORS.BASE_INVERTED};
  border-radius: 4px;
  padding: 5px 10px;
  background-color: ${({ theme }) => theme.COLORS.BASE};
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  vertical-align: middle;
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  cursor: pointer;
  text-transform: uppercase;
  @media only screen and (max-width: 1749px) {
    display: inline-flex;
  }
`;

export const FiltersIcon = styled(Icon).attrs({
  icon: 'TR5-Filters'
})`
  width: 20px;
  margin-left: 9px;
`;

export const StyledListVariantToggle = styled.div`
  display: inline-flex;
  align-items: center;
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
  margin-right: 20px;
  margin-left: 20px;
  vertical-align: middle;
`;

const unselectedIconStyles = css`
  padding: 3px;
  & > path {
    fill: ${({ theme }) => theme.COLORS.NEUTRAL_30};
  }
`;

const selectedIconStyles = css`
  padding: 2px;
  border: 1.6px solid ${({ theme }) => theme.COLORS.BASE_INVERTED};
  border-radius: 2.4px;
  & > path {
    fill: ${({ theme }) => theme.COLORS.BASE_INVERTED};
  }
`;

export const StyledListIcon = styled(Icon).attrs({
  icon: 'TR5-List_toggle'
})`
  cursor: pointer;
  width: 25px;
  margin-left: 12px;
  margin-right: 3px;
  ${({ isSelected }) =>
    isSelected ? selectedIconStyles : unselectedIconStyles};
  @media only screen and (max-width: 1749px) {
    margin-left: 6px;
  }
`;

export const StyledGridIcon = styled(Icon).attrs({
  icon: 'TR5-Grid_toggle'
})`
  cursor: pointer;
  width: 25px;
  ${({ isSelected }) =>
    isSelected ? selectedIconStyles : unselectedIconStyles}
`;
